import React, { useContext } from "react";
import { Button } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import clsx from "clsx";
import { footerControlsStyles } from "./footer-controls.styles";
import { WizardContext, InitialWizard } from "../wizard/context";

export interface FooterControlsStyles {
  step: string;
  isNextButtonDisabled: boolean;
}

export interface FooterControlsProps {
  isBackButtonDisabled: boolean;
  isNextButtonDisabled: boolean;
  hideBackControl: boolean;
  onSubmit: () => void;
  onBack: () => void;
  nextControlText: string;
}

export const FooterControls = ({
  isBackButtonDisabled,
  isNextButtonDisabled = false,
  hideBackControl = false,
  onSubmit,
  onBack,
  nextControlText = "Continue",
}: FooterControlsProps) => {
  const { state } = useContext<InitialWizard>(WizardContext);
  const classes = footerControlsStyles({
    isNextButtonDisabled,
    step: state.step,
  });

  return (
    <div className={classes.flexEnd}>
      <div className={classes.innerContainer}>
        {hideBackControl && (
          <Button
            className={clsx(classes.controls, classes.skip)}
            disabled={!isNextButtonDisabled}
            onClick={onSubmit}
          >
            Skip
          </Button>
        )}
        {!hideBackControl && (
          <Button
            className={clsx(classes.controls, classes.back)}
            disabled={isBackButtonDisabled}
            onClick={onBack}
            startIcon={<ArrowBackIosIcon />}
          >
            Back
          </Button>
        )}
        <Button
          className={classes.controls}
          disabled={isNextButtonDisabled}
          onClick={onSubmit}
          endIcon={
            <ArrowForwardIosIcon
              className={clsx(classes.icon, {
                [classes.iconEnabled]: !isNextButtonDisabled,
              })}
            />
          }
        >
          {nextControlText}
        </Button>
      </div>
    </div>
  );
};
